<template>
    <b-modal title="গ্রাহকের সংযোগ" hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <div class="container custom_modal_body">
            <div class="card">
            <table id="my-table" class="table table-striped table_fields">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Account No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Service</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(application,key) in applications" :key="key">
                        <td>{{key+1}}</td>
                        <td>{{application.account_no}}</td>
                        <td><span v-if="application.user">{{application.user.name}}</span></td>
                        <td><span v-if="application.user">{{application.user.mobile_number}}</span></td>
                        <td><span v-if="application.service">{{application.service.name}}</span></td>
                        <td><button @click="updataApply(application)" class="btn btn-primary btn-sm">বাতিল করুন</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    </b-modal>
</template>

<script>
export default {
    data(){
        return {
            largeModal:false,
            applications:[],
            data:''
        }
    },
    methods:{
        updataApply(application){
            this.largeModal = false
            this.data.application = application;
            this.$emit("updateInfo", this.data);
        },
        openModal(data){
            this.data = data
            this.applications = data.applications
            this.largeModal = true
        }
    },
}
</script>


<style>
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
</style>
